<template>
  <div class="he-tree tree">
    <MyTreeNode
      :data="rootData"
      :store="store"
      :indent="indent"
      :scope="scope"
      :usedKeys="usedKeys"
      >
      <template slot-scope="props">
        <slot :data="props.data" :store="store" :scope="scope" />
      </template>
    </MyTreeNode>
  </div>
</template>

<script>
import { DraggableTree } from 'vue-draggable-nested-tree'
import MyTreeNode from '@/components/MyTreeNode.vue'

export default {
  components: {
    MyTreeNode,
  },
  extends: DraggableTree,
  props: {
    scope: String,
    usedKeys: Array,
  },
}
</script>

<style lang="scss">
  .MyDraggableTree {

  }
</style>



// WEBPACK FOOTER //
// src/components/MyTree.vue